import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { SearchInput } from "@circleco/compass/components/SearchInput";
import type { Ref } from "react";

interface SearchInputFieldProps {
  className?: string;
  inputClassName?: string;
  inputRef: Ref<HTMLInputElement>;
  onChange: (value: string) => void;
  onClose: () => void;
  placeholder: string;
  shouldAnimate?: boolean;
  shouldShowClose?: boolean;
  value: string;
}

export const SearchInputField = ({
  className,
  inputClassName,
  inputRef,
  onChange,
  onClose,
  placeholder,
  shouldAnimate = true,
  shouldShowClose = true,
  value,
}: SearchInputFieldProps) => {
  const handleClear = shouldShowClose ? onClose : () => onChange("");

  return (
    <div
      className={classNames(
        shouldAnimate &&
          "animate-in fade-in slide-in-from-right-2 duration-200",
        inputClassName,
        className,
      )}
    >
      <SearchInput
        ref={inputRef}
        value={value}
        onChange={event => onChange(event.target.value)}
        onClear={handleClear}
        placeholder={placeholder}
        aria-label={placeholder}
      />
    </div>
  );
};
